/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Fullnameplaceholder2Inputs */

const zh_auth_fullnameplaceholder2 = /** @type {(inputs: Auth_Fullnameplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`张三`)
};

const en_auth_fullnameplaceholder2 = /** @type {(inputs: Auth_Fullnameplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John Doe`)
};

const es_auth_fullnameplaceholder2 = /** @type {(inputs: Auth_Fullnameplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juan García`)
};

/**
* | output |
* | --- |
* | "John Doe" |
*
* @param {Auth_Fullnameplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_fullnameplaceholder2 = /** @type {((inputs?: Auth_Fullnameplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Fullnameplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_fullnameplaceholder2(inputs)
	if (locale === "en") return en_auth_fullnameplaceholder2(inputs)
	return es_auth_fullnameplaceholder2(inputs)
});
export { auth_fullnameplaceholder2 as "auth_fullNamePlaceholder" }